/**
 * The fallback model list per provider — NOT the source of truth.
 *
 * Real model lists come from the server's app_provider_models catalogue, discovered off
 * each provider's own /models endpoint (services/chat/modelDiscovery.js) and read via
 * lib/useModelOptions.js. This array is only the floor: what the dropdown shows when a
 * provider has never been synced, has no key, or its catalogue call failed. It is
 * mirrored server-side as CURATED_MODELS in services/chat/modelDiscovery.js.
 *
 * Best-effort, not live-verified — always paired with a "Custom…" free-text escape hatch
 * (components/ModelSelect.jsx), so a wrong or outdated entry here never blocks setting an
 * actual model name.
 *
 * Plain data in its own module rather than a constant inside a component because the
 * workflow palette (lib/workflowPalette.js) needs the list without pulling React in.
 */
export const MODEL_OPTIONS = {
  openai: ['gpt-4o', 'gpt-4o-mini', 'gpt-4.1', 'gpt-4.1-mini', 'o3-mini'],
  anthropic: ['claude-sonnet-5', 'claude-opus-4-8', 'claude-haiku-4-5-20251001', 'claude-fable-5'],
  gemini: ['gemini-2.0-flash', 'gemini-2.0-pro', 'gemini-1.5-flash', 'gemini-1.5-pro'],
  grok: ['grok-2', 'grok-2-mini', 'grok-beta'],
  // openrouter and opencode-go are deliberately absent. OpenRouter proxies hundreds of
  // upstream models under "vendor/model" ids, so any list would be arbitrary; OpenCode
  // Go's roster turns over with each release, which is the exact staleness a floor here
  // would reintroduce. Discovery covers both instead — each publishes a public /models
  // endpoint, so neither needs a key to enumerate.
};

export default MODEL_OPTIONS;
